import React from 'react';

import PropTypes from 'prop-types';

import {
  energyExtension,
  gasExtension,
  selectedTestSuiteValue,
  shouldFillDebTestData,
} from 'components/DEBForm/Utils/DebTestSetup';
import { InstallerBranchExtensionCheckboxes } from 'components/FormHelper/FormTestingBanners/InstallerBranchExtensionCheckboxes';
import { InputField } from 'components/FormHelper/InputField';
import { LabelCheckbox } from 'components/LabelCheckbox/LabelCheckbox';

import { DEB_ACTIVE_PAGE, STORAGE_KEY } from 'global/constants';

import { getTestingAccountItemMap } from 'utils/FormUtils';
import { isProduction } from 'utils/StageUtils';
import { getTenantId } from 'utils/tenantUtil';

import './FormTestingBanner.sass';

export const DebFormTestingBanner = ({ activePage, installerStatusSummary }) => {
  const toggleTestSetup = () => {
    localStorage.setItem(STORAGE_KEY.FILL_DEB_FORM, !shouldFillDebTestData);
    window.location.reload();
  };
  const changeTestingAccount = (e) => {
    localStorage.setItem(STORAGE_KEY.DEB_SELECTED_TEST_SUITE, e.target.value);
    window.location.reload();
  };
  const toggleEnergyExtension = () => {
    localStorage.setItem(STORAGE_KEY.ENERGY_EXTENSION, !energyExtension);
    window.location.reload();
  };

  const toggleGasExtension = () => {
    localStorage.setItem(STORAGE_KEY.GAS_EXTENSION, !gasExtension);
    window.location.reload();
  };

  if (isProduction() || !installerStatusSummary) {
    return null;
  }

  const renderBannerContent = () => {
    if (activePage === DEB_ACTIVE_PAGE.FORM_PAGE) {
      return (
        <div className="test-alert-container">
          <LabelCheckbox
            tooltipText="Für das Testing im DEB werden eingehende Daten simuliert. Es können Änderungen vom Tester vorgenommen werden."
            name="testSetupDEB"
            id="testSetupDEB"
            testId="testSetupDEB"
            value={shouldFillDebTestData}
            onChange={toggleTestSetup}
            label="Testdaten laden?"
          />
          {shouldFillDebTestData && (
            <div className="test-alert">
              <div className="test-alert__input-field">
                <InputField
                  fullWidth
                  select
                  items={getTestingAccountItemMap(getTenantId())}
                  label="Testfall wählen"
                  onChange={changeTestingAccount}
                  name="selectedTestAccount"
                  id="selectedTestAccount"
                  value={selectedTestSuiteValue}
                  testId="selectedTestAccountDEB"
                  oldValue=""
                />
              </div>
              <InstallerBranchExtensionCheckboxes
                energyExtension={energyExtension}
                gasExtension={gasExtension}
                toggleEnergyExtension={toggleEnergyExtension}
                toggleGasExtension={toggleGasExtension}
                installerStatusSummary={installerStatusSummary}
              />
            </div>
          )}
        </div>
      );
    }
    if (shouldFillDebTestData) {
      return (
        <div className="test-alert-container">
          <div>
            <span className="test-alert-bold">Geladene Testdaten: </span>{' '}
            {
              getTestingAccountItemMap(getTenantId()).find(
                (it) => it.value === selectedTestSuiteValue
              ).label
            }
          </div>
          <div>
            <span className="test-alert-bold">Bitte beachten: </span> Änderungen können durch den
            Tester vorgenommen werden
          </div>
        </div>
      );
    }
    return null;
  };

  return <div className="test-container">{renderBannerContent()}</div>;
};
DebFormTestingBanner.propTypes = {
  activePage: PropTypes.number,
  installerStatusSummary: PropTypes.object,
};
DebFormTestingBanner.defaultProps = {
  activePage: DEB_ACTIVE_PAGE.FORM_PAGE,
  installerStatusSummary: {},
};
